import { trackEvent } from 'helpers/analytics';
import { useCallback } from 'react';
import {
  useAddContactToSharedListMutation,
  useCreateSharedListMutation,
  useRemoveContactFromSharedListMutation,
} from 'services/contacts';

export const useAddListToSingleContacts = ({ queryParams, contact, activeNetwork, origin, page }) => {
  const [addContactToSharedList] = useAddContactToSharedListMutation();
  const [removeContactFromSharedList] = useRemoveContactFromSharedListMutation();
  const [createSharedList, { isLoading: isCreatingSharedList }] = useCreateSharedListMutation();

  const onChangeList = useCallback(
    (sharedLists, opt, checked) => {
      if (checked) {
        addContactToSharedList({
          queryParams,
          contactId: contact?.id,
          list: sharedLists?.find((list) => list?.id === opt.value),
        });

        trackEvent('contacts:list:add_contact_single', {
          listId: opt.value,
          collectionId: activeNetwork?.id,
          origin,
          page,
        });
      } else {
        removeContactFromSharedList({
          queryParams,
          contactId: contact?.id,
          list: { id: opt.value },
        });

        trackEvent('contacts:list:remove_contact_single', {
          listId: opt.value,
          collectionId: activeNetwork?.id,
          origin,
          page,
        });
      }
    },
    [addContactToSharedList, queryParams, contact?.id, activeNetwork?.id, origin, page, removeContactFromSharedList],
  );

  const onCreateList = useCallback(
    async (listName) => {
      const { data } = await createSharedList({ name: listName });

      trackEvent('lists:create_list', {
        collection_id: activeNetwork.id,
        object_type: 'people',
      });
      addContactToSharedList({ queryParams, contactId: contact?.id, list: data.sharedList });
    },
    [addContactToSharedList, queryParams, contact?.id, activeNetwork?.id, createSharedList],
  );

  return { onChangeList, onCreateList, isLoading: isCreatingSharedList };
};
